import { usePostModel, usePostFormData } from "~/Hooks/Api/RestRequests";
import { Dictionary } from "~/Types/Common";

export interface TranslateSingleValue {
    originalValue: string;
    sourceLanguage: string;
    targetLanguages: string[];
}

export const useUploadGlossary = () => {
    return usePostFormData("translations/glossary");
};
export const useTranslationSingleValue = () => {
    return usePostModel<TranslateSingleValue, TranslationResponse>("translations/singleValue");
};
export const useSaveContentValue = () => {
    return usePostModel("contents");
};

interface TranslationResponse {
    isSuccess: boolean;
    value?: {
        originalValue: boolean;
        sourceLanguage: string;
        translationValues: Dictionary<string>;
        errorMessage?: string;
    };
}
